export default "__VITE_ASSET__8dacea4d__"